export default __webpack_public_path__ + "static/floor2-slide-1-d8c7c5d88ed0492368dd4757e970efcb.jpg";